import { useEffect, useState, useMemo } from "react";

import {
  courtWeekday,
  formatCourtDate,
  formatCourtTime,
  getActEndpoint,
  getActTime,
} from "@/Utils/litigationDates.mjs";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";

import api from "../../../api/api";
// import { setCaseId, setClientId } from "../../../Utils/helper";
// import { fetchCaseSummary, fetchHeaderSummary } from "../../../api/case";
// import {
//   fetchAllPages,
//   fetchCurrentCase,
//   setCaseSummary,
// } from "../../../Redux/caseData/caseDataSlice";
// import { setHeaderName } from "../../../Redux/header_name/action";
// import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
// import { setHeaderSummary } from "../../../Redux/header/headerDataSlice";
import SOLicon from "../../../assets/litigation/sol.svg";
import TodoCompletionMarkingModal from "../../TodoDashboard/modal/TodoCompletionMarkingModal";

import avatarImage from "./../../../assets/images/avatar.svg";
const EVENT_TYPE_ICONS = {
  Filing: "ic-Filing",
  Hearing: "ic-Hearing",
  Motion: "ic-Motion",
  Discovery: "ic-discovery",
  Deposition: "ic-Deposition",
  Exam: "ic-Exam",
  Trial: "ic-Trial",
  Deadline: "ic-Deadline",
  Event: "ic-Event",
  Subpoenas: "ic-Event",
  "Case Initiation": "ic-Case-Initiation",
  "Mediation / Arbitration": "ic-Mediation-Arbitration",
  "Settlement Conference": "ic-Settlement-Conference",
  Answer: "ic-Answer",
  "Expert Discovery": "ic-discovery",
  "Treatment Dates": "ic-Event",
  Tasks: "ic-Event",
};

const CasesTimeline = (_chats) => {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const [caseTimeline, setCaseTimeline] = useState([]);
  const [showTodoCompletionModal, setShowTodoCompletionModal] = useState(false);
  const [selectedTaskData, setSelectedTaskData] = useState(null);

  const handleOpenModal = (section) => {
    if (section.isTask) {
      setSelectedTaskData(section.obj);
      setShowTodoCompletionModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowTodoCompletionModal(false);
    setSelectedTaskData(null);
  };

  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const changeCase = async (client_id, case_id) => {
  //   dispatch(setComponentLoadingEffect("medicalProviders", true));
  //   dispatch(setComponentLoadingEffect("detailBar", true));

  //   // eslint-disable-next-line unused-imports/no-unused-vars
  //   const response = await api.get(`/api/switch_client/${client_id}/${case_id}/1/`);

  //   setClientId(client_id);
  //   setCaseId(case_id);
  //   dispatch(fetchCurrentCase(client_id, case_id));
  //   fetchHeaderSummary(client_id, case_id)
  //     .then((data) => {
  //       dispatch(setHeaderSummary(data));
  //       navigate(`/bp-case/${client_id}/${case_id}`, {
  //         replace: true,
  //       });
  //     })
  //     .catch(() => {});

  //   fetchCaseSummary(client_id, case_id)
  //     .then((data) => {
  //       dispatch(setCaseSummary(data));
  //       dispatch(fetchAllPages(case_id));
  //       dispatch(setHeaderName("Case"));
  //     })
  //     .catch(() => {});
  // };

  const fetchCaseTimeline = async () => {
    try {
      const response = await api.get(`${origin}/api/homepage/case-timeline/`);
      if (response.status === 200) {
        setCaseTimeline(response.data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  useEffect(() => {
    fetchCaseTimeline();
  }, []);

  const isSOL = (eventType) =>
    eventType === "Statute of Limitations" ||
    eventType === "Statute Of Limitations" ||
    eventType === "S.O.L";

  const getEventType = (event) => {
    if (event.type === "Litigation") {
      return "Statute of Limitations";
    }
    return event.type || "Other";
  };

  // Build flat render sections from the timeline data
  const sections = useMemo(() => {
    const result = [];

    if (!caseTimeline || caseTimeline.length === 0) return result;

    caseTimeline.forEach((item) => {
      const dateStr = item.date;
      const dayName = courtWeekday(dateStr);
      const formatted = formatCourtDate(dateStr);

      // Date heading
      result.push({ type: "dateHeading", dayName, formatted });

      // Group events by client (preserving order)
      const clientGroups = {};
      const clientOrder = [];
      item.events.forEach((evt) => {
        const client = evt.event.for_case?.for_client;
        if (!client) return;
        const clientKey = `${client.id}-${evt.event.for_case.id}`;
        if (!clientGroups[clientKey]) {
          clientGroups[clientKey] = {
            client,
            case_id: evt.event.for_case.id,
            litigationEvents: [],
            treatmentEvents: [],
            taskEvents: [],
          };
          clientOrder.push(clientKey);
        }
        if (evt.type === "Litigation") {
          clientGroups[clientKey].litigationEvents.push(evt);
        } else if (evt.type === "Treatment Dates") {
          clientGroups[clientKey].treatmentEvents.push(evt);
        } else if (evt.type === "Tasks") {
          clientGroups[clientKey].taskEvents.push(evt);
        } else {
          clientGroups[clientKey].litigationEvents.push(evt);
        }
      });

      // Render each client's section: avatar → their events
      clientOrder.forEach((clientKey) => {
        const group = clientGroups[clientKey];

        // Client avatar
        result.push({
          type: "clientRow",
          client: group.client,
          case_id: group.case_id,
        });

        // Keep the existing clock heading for each group of court-clock acts.
        const timedGroups = new Map();
        group.litigationEvents.forEach((evt) => {
          const field = evt.type === "SOL" ? "end_date" : getActEndpoint(evt.event);
          const time = getActTime(evt.event, field) || "";
          if (!timedGroups.has(time)) timedGroups.set(time, []);
          timedGroups.get(time).push(evt);
        });
        [...timedGroups.keys()].sort().forEach((time) => {
          result.push({ type: "categoryLabel", label: formatCourtTime(time) || "All Day" });
          const litTypeGroups = {};
          timedGroups.get(time).forEach((evt) => {
            const eventType = getEventType(evt);
            if (!litTypeGroups[eventType]) litTypeGroups[eventType] = [];
            litTypeGroups[eventType].push(evt);
          });
          Object.entries(litTypeGroups).forEach(([eventType, events]) => {
            result.push({ type: "eventTypeHeading", eventType });
            events.forEach((evt) =>
              result.push({
                type: "actName",
                name: evt.event.name,
                client: group.client,
                case_id: group.case_id,
              })
            );
          });
        });

        // Treatment Dates: just the name
        group.treatmentEvents.forEach((evt) => {
          result.push({
            type: "actName",
            name: evt.event.name,
            client: group.client,
            case_id: group.case_id,
          });
        });

        // Tasks: just the name
        group.taskEvents.forEach((evt) => {
          result.push({
            type: "actName",
            isTask: true,
            obj: evt.obj,
            name: evt.event.name,
            client: group.client,
            case_id: group.case_id,
          });
        });
      });
    });

    return result;
  }, [caseTimeline]);

  const renderSection = (section, index) => {
    switch (section.type) {
      case "dateHeading":
        return (
          <div
            key={`date-${index}`}
            className="d-flex justify-content-center task"
            style={{ padding: "0px 5px", height: "21px", color: "var(--primary)" }}
          >
            <strong>
              {section.dayName}, {section.formatted}
            </strong>
          </div>
        );
      case "clientRow":
        return (
          <div
            key={`client-${index}`}
            className="td-autosize d-flex align-items-center task"
            style={{ padding: "0px 5px", height: "21px", cursor: "pointer", fontWeight: "600" }}
            // onClick={() => changeCase(section.client.id, section.case_id)}
            onClick={() => handleOpenModal(section)}
          >
            <span
              className="ic ic-avatar ic-15 has-avatar-icon has-cover-img bg-white"
              style={{ minWidth: "15px" }}
            >
              <img
                src={section.client.profile_pic_19p ?? avatarImage}
                style={{
                  background: "var(--primary-30)",
                }}
                className="theme-ring"
                alt=""
              />
            </span>
            <span
              className="ms-1 client-type d-block align-items-center"
              style={{ textAlign: "left" }}
            >
              {section.client.last_name?.trim()}, {section.client.first_name?.trim()}
            </span>
          </div>
        );
      case "categoryLabel":
        return (
          <div
            key={`cat-${index}`}
            className="d-flex justify-content-center task"
            style={{ padding: "0px 5px", height: "21px", color: "var(--primary)" }}
          >
            <strong>{section.label}</strong>
          </div>
        );
      case "eventTypeHeading":
        return (
          <div
            key={`evt-${index}`}
            className="d-flex align-items-center justify-content-center"
            style={{ padding: "0px 5px", height: "21px", fontWeight: "600" }}
          >
            {isSOL(section.eventType) ? (
              <span className="d-flex align-items-center justify-content-center ic ic-15 m-r-5">
                <img
                  src={SOLicon}
                  className="d-flex align-items-center justify-content-center ic-15"
                  alt=""
                />
              </span>
            ) : (
              <i
                className={`ic ic-15 ${EVENT_TYPE_ICONS[section.eventType] || "ic-Event"} m-r-5`}
              />
            )}
            <span className="ms-0">{section.eventType}</span>
          </div>
        );
      case "actName":
        return (
          <div
            key={`act-${index}`}
            className="d-flex align-items-center"
            style={{ cursor: "pointer" }}
            // onClick={() => changeCase(section.client.id, section.case_id)}
            onClick={() => handleOpenModal(section)}
          >
            <div
              className="p-l-5"
              style={{
                maxWidth: "150",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontWeight: "600",
                height: "21px",
                paddingLeft: "25px",
              }}
            >
              {section.name}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="case-timeline right-calendar border-0 h-100" style={{ width: "188px" }}>
        <div className="bg-primary-5 height-25 has-sticky-header">
          <h4 className="client-contact-title text-center height-25 d-flex justify-content-center align-items-center h-100">
            Timeline for All Cases
          </h4>
        </div>
        <div className="calendar-borders position-relative border-0 case-timeline-no-scrollbar">
          {sections.length > 0 ? (
            sections.map((section, index) => renderSection(section, index))
          ) : (
            <div>No events available</div>
          )}
        </div>
      </div>
      {showTodoCompletionModal && selectedTaskData && (
        <TodoCompletionMarkingModal
          show={showTodoCompletionModal}
          handleClose={handleCloseModal}
          selectedData={selectedTaskData}
          pageObj={{}}
        />
      )}
    </>
  );
};

export default CasesTimeline;
